import { h, Component } from 'preact';
import { Router } from 'preact-router';
import style from './style.css';
import SpinButton from '../spin-button';
import BackButton from '../back-button';
import { withTranslation } from "react-i18next";
import { AppConstant } from '../../constant/AppConstant';
import { resetSession } from '../../services/sessionReset';
 class Header extends Component {

	// Ends the WHOLE session — token, app state, caches, polling — not just
	// the token; otherwise the next account in this tab sees the previous
	// one's sites (audit 2026-10-15, M5). See services/sessionReset.js.
	logout = () => {
		resetSession(this.props.app);
		Router.route("/");
	};

	render() {
		let self = this;
		const {t}=self.props
		return (
			<header class={style.header}>
				<div class={`p-2 ${style.headerInner}`}>
					<BackButton app={self.props.app} />
					<span class={`font-weight-bold ${style.headerTitle}`}>{self.props.headerName}</span>
					<div class={style.headerRight}>
						<SpinButton class="d-inline-block btn-sm btn-outline-secondary font-weight-light"
							icon="fa-sign-out"
							title={t(AppConstant.LOGOUT)}
							onClick={self.logout} />
					</div>
				</div>
			</header>
		);
	}
}
export default withTranslation()(Header);
